<div class="jumbotron jumbotron-fluid center-screen">
  <div style="position: absolute; top: 16px; right: 16px; z-index: 10;">
    <button mat-button (click)="switchLanguage('en')">EN</button>
    <button mat-button (click)="switchLanguage('he')">HE</button>
  </div>

  <div>
    <h1>
      <img src="./assets/datakamalogo.svg" alt="data*kama" width="200" height="120" />
    </h1>

    <form
      *ngIf="phase === 'tenant'"
      [formGroup]="tenantForm"
      (submit)="$event.preventDefault(); continueLogin()"
    >
      <mat-card class="card">
        <mat-card-title>{{ 'WHATSAPP.TITLE' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'WHATSAPP.TENANT_SUBTITLE' | translate }}</mat-card-subtitle>
        <mat-card-content>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LOGIN.BUSINESS_NAME' | translate }}</mat-label>
            <input
              matInput
              type="text"
              id="tenantname"
              formControlName="tenantName"
              placeholder="{{ 'LOGIN.ENTER_BUSINESS_NAME' | translate }}"
              [ngClass]="displayFieldCss('tenantName')"
              required
            />
            <mat-icon matSuffix>home</mat-icon>
          </mat-form-field>
          <mat-card-actions>
            <div class="button-panel">
              <button mat-raised-button color="primary" type="submit" [disabled]="!tenantForm.valid">
                {{ 'LOGIN.SUBMIT' | translate }}
              </button>
            </div>
          </mat-card-actions>
        </mat-card-content>
      </mat-card>
    </form>

    <div *ngIf="phase === 'sign-in'" class="sign-in-panel">
      <mat-card class="card card--intro">
        <mat-card-subtitle>{{ 'WHATSAPP.SIGN_IN_SUBTITLE' | translate }}</mat-card-subtitle>
        <mat-card-subtitle *ngIf="tenantDisplayName">
          {{ 'WHATSAPP.WORKSPACE' | translate }}: <strong>{{ tenantDisplayName }}</strong>
        </mat-card-subtitle>
      </mat-card>
      <amplify-authenticator [hideSignUp]="true">
        <!-- Same gate as NavComponent: link only after JWT tenant matches selected business. -->
        <ng-template amplifySlot="authenticated" let-user="user">
          <app-verify-tenant-session [user]="user"></app-verify-tenant-session>
          <ng-container *ngIf="authConfigService.sessionAllowed$ | async; else verifyingTenantSession">
            <app-whatsapp-link-handler
              [linkSessionId]="sessionId || ''"
              (completed)="onLinkSuccess()"
              (failed)="onLinkFailed($event)"
            ></app-whatsapp-link-handler>
          </ng-container>
          <ng-template #verifyingTenantSession>
            <mat-card class="card">
              <mat-card-content class="verifying-tenant">
                <mat-spinner diameter="40"></mat-spinner>
              </mat-card-content>
            </mat-card>
          </ng-template>
        </ng-template>
      </amplify-authenticator>
    </div>

    <mat-card *ngIf="phase === 'success'" class="card card--success">
      <mat-card-title>
        <mat-icon color="primary">check_circle</mat-icon>
        {{ 'WHATSAPP.SUCCESS_TITLE' | translate }}
      </mat-card-title>
      <mat-card-content>
        <p>{{ 'WHATSAPP.SUCCESS_BODY' | translate }}</p>
        <p class="hint">{{ 'WHATSAPP.SUCCESS_CLOSE' | translate }}</p>
        <p *ngIf="tenantDisplayName" class="workspace">
          {{ 'WHATSAPP.WORKSPACE' | translate }}: <strong>{{ tenantDisplayName }}</strong>
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="phase === 'error'" class="card card--error">
      <mat-card-title>{{ 'WHATSAPP.LINK_FAILED' | translate }}</mat-card-title>
      <mat-card-content>
        <p>{{ errorMessage }}</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>